import { ChangeEvent, ReactElement } from 'react';
import { Pagination, PaginationProps } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

export interface PoolPaginationProps extends Omit<PaginationProps, 'count'> {
    pages?: number;
    siblingCount: number;
}

export const PoolPagination = (props: PoolPaginationProps): ReactElement | null => {
    const { pages = 0, onChange, ...paginationProps } = props;
    const [searchParams, setSearchParams] = useSearchParams();

    const handlePaginationChanged = (e: ChangeEvent<unknown>, page: number): void => {
        searchParams.set('page', page.toString());
        setSearchParams(searchParams);
        onChange?.(e, page);
    };

    if (pages <= 1) {
        return null;
    }

    return (
        <Pagination
            count={Math.min(100, pages)}
            boundaryCount={1}
            onChange={handlePaginationChanged}
            {...paginationProps}
        />
    );
};
